<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card class="ma-5 pa-3 live-trade-details-card rounded-0" elevation="0"
          :color="$vuetify.theme.dark ? '#162334' : '#E0EAF2'">
          <v-card-title class="title px-1 pb-7 pt-5">
            <span>Partner Withdraw Request</span>
          </v-card-title>

          <v-row class="no-gutters align-center">
            <v-col cols="12" sm="12" md="4" lg="3" class="mb-3 mb-lg-0">
              <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here ..."
                single-line solo hide-details />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="2" class="mb-3 mb-lg-0">
              <v-select solo :items="trxMethods" v-model="seletedDropdownTrx" item-text="text" item-value="value"
                @change="handleTrxMethodChange" append-icon="mdi-chevron-down" label="All Trx. Method"
                class="custom-select" />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="2" class="mb-3 mb-lg-0">
              <v-select solo :items="allStatus" v-model="seletedDropdownStatus" item-text="text" item-value="value"
                @change="handleStatusChange" append-icon="mdi-chevron-down" label="All Status" class="custom-select" />
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="3" class="mb-3 mb-lg-0">
              <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="selectedDatesText" placeholder="Date filter" prepend-icon="mdi-calendar"
                    append-icon="mdi-chevron-down" readonly v-bind="attrs" v-on="on" solo class="custom-select" />
                </template>

                <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
                  <v-spacer></v-spacer>
                  <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="cancelSelection">
                    Cancel
                  </v-btn>
                  <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="confirmSelection">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="2" class="mb-lg-0">
              <ul class="mt-0 justify-end">
                <li class="mr-3 mr-lg-0">
                  <span class="text--green">Approved Withdraws:</span>
                  <span class="text-right">{{ totalApprovedRequests }}</span>
                </li>
              </ul>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="1" class="mb-lg-0" v-if="$canRoute('withdraw-requests') === 1" align="middle">
              <v-btn
                @click.prevent="downloadCSVexcel"
                :loading="excelLoading"
                :disabled="excelLoading"
                tile
                elevation="0"
                class="mt-6 text-capitalize btn-account mb-0 mx-0"
                color="greenMain"
              >
                <v-icon small>mdi mdi-tray-arrow-down</v-icon>Excel
              </v-btn>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                <v-sheet class="transactionTable depositTabTable registerUserTable"
                  :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                  <v-data-table :headers="headers" :items="withdraws" :server-items-length="pagination?.total || 10"
                    :options.sync="options" :loading="isFetchLoading" :items-per-page="options.itemsPerPage"
                    :footer-props="{
                      'items-per-page-options': [10, 25, 50, 100],
                      'items-per-page-text': 'Rows per page:'
                    }" @update:options="handleOptionsChange" disable-sort>
                    <template v-slot:loading>
                      <div class="d-flex align-center justify-center pa-4">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        <span class="ml-2">Loading data...</span>
                      </div>
                    </template>

                    <template v-slot:no-data>
                      <div class="d-flex align-center justify-center pa-4">
                        <v-icon color="secondary">mdi-information</v-icon>
                        <span class="ml-2">No data found</span>
                      </div>
                    </template>

                    <template v-slot:no-results>
                      <div class="d-flex align-center justify-center pa-4">
                        <v-icon color="secondary">mdi-magnify</v-icon>
                        <span class="ml-2">No matching data found</span>
                      </div>
                    </template>

                    <template v-slot:item.created_at="{ item }">
                      {{ formatMySQLDate(item?.created_at) }}
                    </template>

                    <template v-slot:item.account_fullname="{ item }" v-if="$canRoute('registered-user?tab=1') === 1">
                      <router-link class="text-capitalize text--ash"
                        :to="`/registered-user-details/${item?.client_account_id}`">
                        {{ `${item.account_fullname} (${item?.client_account_id})` }}
                      </router-link>
                    </template>

                    <template v-slot:item.account_fullname="{ item }" v-else>
                      <span class="text-capitalize text--ash">
                        {{ `${item.account_fullname} (${item?.client_account_id})` }}
                      </span>
                    </template>

                    <template v-slot:item.payment_system="{ item }">
                      {{ item?.payment_system?.method_name || "N/A" }}
                    </template>

                    <template v-slot:item.admin_name="{ item }">
                      {{ item?.admin_name || "N/A" }}
                    </template>

                    <template v-slot:item.account_email="{ item }">
                      <v-tooltip top color="#000">
                        <template v-slot:activator="{ on }">
                          <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                            {{ obfuscateAnyEmail(item?.account_email) }}
                            <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                              {{ copiedStates[item.id] ? "mdi mdi-check" : "mdi-content-copy" }}
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ item.account_email }}</span>
                      </v-tooltip>
                    </template>

                    <template v-slot:item.status="{ item }">
                      <div class="status-selection">
                        <v-select
                          solo
                          dense
                          class="custom-select"
                          :items="updateslots"
                          v-model="item.status"
                          item-text="statusText"
                          item-value="status"
                          disabled
                          hide-details
                          :append-icon="
                            item.status === 1
                              ? 'mdi-checkbox-marked-circle'
                              : item.status === 2
                              ? 'mdi-cancel'
                              : 'mdi-clock-outline'
                          "
                        >
                          <template v-slot:selection="{ item }">
                            <div :class="getTextColor(item)">
                              {{
                                item.status === 0
                                  ? "Pending"
                                  : item.status === 1
                                  ? "Approved"
                                  : "Rejected"
                              }}
                            </div>
                          </template>
                        </v-select>
                      </div>
                    </template>

                    <!-- <template v-slot:item.status="{ item }">
                      <div class="status-selection">
                        <v-select solo :items="updateslots" class="custom-select" v-model="item.status"
                          item-text="statusText" item-value="status"
                          :disabled="item.status > 0 || $canRoute('withdraw-requests') !== 1"
                          @change="handleSelectChange(item)">
                          <template v-slot:selection="{ item }">
                            <div :class="getTextColor(item)">
                              {{
                                item.status === 0
                                  ? "Pending"
                                  : item.status === 1
                                    ? "Approved"
                                    : item.status === 2
                                      ? "Rejected"
                                      : null
                              }}
                            </div>
                          </template>
                        </v-select>
                      </div>
                    </template> -->

                    <template v-slot:item.details="{ item }">
                      <v-dialog transition="scale-transition" origin="center center" max-width="985px"
                        v-model="detailsDialog[item?.id]" content-class="deposit-modal" scrollable eager>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="d-flex align-items-center">
                            <div v-bind="attrs" v-on="on">
                              <!-- CHANGED: pass full item (so we can generate QR) -->
                              <v-icon color="#039de9" small @click="handleFile(item)">
                                mdi-eye-outline
                              </v-icon>
                            </div>
                          </div>
                        </template>

                        <template>
                          <v-card :color="$vuetify.theme.dark ? '#162334' : '#e8f1f8'" class="deposit-form">
                            <v-btn class="close-btn" icon dark @click="handleClose(item)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>

                            <v-card-title>
                              <div class="image-details">
                                <v-img src="@/assets/bank-transfer.png"></v-img>
                                <h3>{{ item?.payment_system?.method_name }}</h3>
                              </div>
                              <div class="content-details">
                                <h3>Withdrawal:</h3>
                                <span>${{ item?.amount }}</span>
                              </div>
                            </v-card-title>

                            <div v-if="selectedFile">
                              <div class="img-center" v-if="isImage(item?.payment_slip)">
                                <img :src="item.payment_slip" class="modal-img" />
                              </div>

                              <div v-else-if="isPDF(item?.payment_slip)">
                                <iframe :src="item.payment_slip" width="100%" class="modal-iframe" height="250px"
                                  frameborder="0"></iframe>
                              </div>

                              <div v-else>
                                <p class="text-center">Unsupported file format.</p>
                              </div>
                            </div>

                            <div v-else>
                              <p class="text-center">No document preview available.</p>
                            </div>

                            <v-card-subtitle v-if="selectedFile">
                              <div class="download-icon cursor-pointer" @click="downloadFile(item?.payment_slip)">
                                <p>Download</p>
                                <v-icon small slot="append" color="#039de9">mdi-tray-arrow-down</v-icon>
                              </div>
                              <div class="tab-details cursor-pointer" @click="openInNewTab(item?.payment_slip)">
                                <p>Open In New Tab</p>
                                <v-icon small slot="append" color="#039de9">mdi-eye</v-icon>
                              </div>
                            </v-card-subtitle>

                            <v-card-text>
                              <v-row>
                                <v-col cols="12">
                                  <h1>All Information</h1>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                  <fieldset>
                                    <legend>Name</legend>
                                    <v-text-field readonly :value="item?.account_fullname" single-line solo hide-details
                                      class="custom-select" />
                                  </fieldset>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                  <fieldset>
                                    <legend>Email</legend>
                                    <v-text-field readonly :value="item?.account_email" single-line solo hide-details
                                      class="custom-select" />
                                  </fieldset>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                  <fieldset>
                                    <legend>Account No</legend>
                                    <v-text-field readonly :value="item?.trading_account_no" single-line solo
                                      hide-details class="custom-select" />
                                  </fieldset>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                  <fieldset>
                                    <legend>Transaction Method</legend>
                                    <v-text-field readonly :value="item?.payment_system?.method_name" single-line solo
                                      hide-details class="custom-select" />
                                  </fieldset>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                  <fieldset>
                                    <legend>Transaction ID</legend>
                                    <v-text-field readonly :value="item?.transaction_id || 'N/A'" single-line solo
                                      hide-details class="custom-select" />
                                  </fieldset>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                  <fieldset>
                                    <legend>Amount</legend>
                                    <v-text-field readonly :value="item?.amount" single-line solo hide-details
                                      class="custom-select" />
                                  </fieldset>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                  <fieldset>
                                    <legend>Trx. Fee</legend>
                                    <v-text-field readonly :value="item?.trx_fee" single-line solo hide-details
                                      class="custom-select" />
                                  </fieldset>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                  <fieldset>
                                    <legend>Net Amount</legend>
                                    <v-text-field readonly :value="item?.net_amount" single-line solo hide-details
                                      class="custom-select" />
                                  </fieldset>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                  <fieldset>
                                    <legend>Reference No.</legend>
                                    <v-text-field readonly :value="item?.reference" single-line solo hide-details
                                      class="custom-select" />
                                  </fieldset>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                  <fieldset>
                                    <legend>Time</legend>
                                    <v-text-field readonly :value="item?.created_at" single-line solo hide-details
                                      class="custom-select" />
                                  </fieldset>
                                </v-col>

                                <!-- ADDED: Network (if exists) -->
                                <v-col v-if="item?.network" cols="12" sm="12" md="6">
                                  <fieldset>
                                    <legend>Network</legend>
                                    <v-text-field readonly :value="item?.network" single-line solo hide-details
                                      class="custom-select" />
                                  </fieldset>
                                </v-col>

                                <!-- ADDED: Wallet Address + Copy -->
                                <v-col v-if="item?.wallet_address" cols="12" sm="12" md="6">
                                  <fieldset>
                                    <legend>Crypto Address</legend>
                                    <v-text-field readonly :value="item?.wallet_address" single-line solo hide-details
                                      class="custom-select">
                                      <v-icon small slot="append" class="cursor-pointer"
                                        :color="walletCopied[item.id] ? 'green' : '#039de9'"
                                        @click.stop="copyWalletAddress(item)"
                                        :title="walletCopied[item.id] ? 'Copied' : 'Copy address'">
                                        {{ walletCopied[item.id] ? 'mdi-check' : 'mdi-content-copy' }}
                                      </v-icon>
                                    </v-text-field>
                                  </fieldset>
                                </v-col>

                                <!-- ADDED: Wallet QR -->
                                <v-col v-if="shouldShowWalletQr(item)" cols="12" class="d-flex justify-center">
                                  <fieldset class="qr-fieldset">
                                    <legend>Wallet QR</legend>

                                    <div class="qr-wrap">
                                      <v-progress-circular v-if="qrLoading[item.id]" indeterminate size="28" width="2"
                                        color="primary" />
                                      <v-img v-else-if="walletQr[item.id]" :src="walletQr[item.id]" width="180"
                                        height="180" contain class="qr-img" />
                                      <div v-else class="text-caption text--ash text-center">
                                        QR not available
                                      </div>
                                    </div>

                                    <div class="d-flex justify-center mt-3">
                                      <v-btn small text class="text-capitalize" color="#039de9"
                                        @click="copyWalletAddress(item)">
                                        <v-icon small class="mr-1" :color="walletCopied[item.id] ? 'green' : '#039de9'">
                                          {{ walletCopied[item.id] ? 'mdi-check' : 'mdi-content-copy' }}
                                        </v-icon>
                                        {{ walletCopied[item.id] ? 'Copied' : 'Copy Address' }}
                                      </v-btn>
                                    </div>
                                  </fieldset>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                  <fieldset>
                                    <legend>Verification Image</legend>
                                    <v-text-field readonly :value="item?.payment_slip" single-line solo hide-details
                                      class="custom-select">
                                      <v-icon small slot="append" color="#039de9"
                                        @click="downloadFile(item?.payment_slip)">
                                        mdi-tray-arrow-down
                                      </v-icon>
                                    </v-text-field>
                                  </fieldset>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                  <fieldset>
                                    <legend>Status</legend>
                                    <v-text-field readonly
                                      :value="item?.status === 0 ? 'Pending' : item?.status === 1 ? 'Approved' : 'Rejected'"
                                      single-line solo hide-details class="custom-select">
                                      <v-icon small slot="prepend" color="#FFC020">mdi-star-outline</v-icon>
                                    </v-text-field>
                                  </fieldset>
                                </v-col>

                                <v-col cols="12">
                                  <fieldset>
                                    <legend>Remarks</legend>
                                    <v-text-field readonly :value="item?.remarks" single-line solo hide-details
                                      class="custom-select" />
                                  </fieldset>
                                </v-col>
                              </v-row>

                              <v-row v-if="item?.status === 0">
                                <v-col cols="12">
                                  <h3 class="text-success">Upload A Pay Slip</h3>
                                </v-col>
                                <v-col cols="12">
                                  <fieldset>
                                    <legend>Proof</legend>
                                    <v-file-input v-model="pay_slip" label="Choose file in needed (Max Size 2MB)"
                                      single-line solo prepend-icon="mdi-file-image" class="custom-select"
                                      @change="onFileChange" />
                                  </fieldset>
                                  <v-img v-if="previewUrl" class="img-logo-bank" :src="previewUrl"></v-img>
                                  <span v-if="errors.pay_slip" class="error-message">{{ errors.pay_slip }}</span>
                                </v-col>
                              </v-row>

                              <v-row v-if="isItOpen(item) && $canRoute('withdraw-requests') === 1 && canHandleMethod(item)">
                                <v-col cols="6">
                                  <div class="button-wrapper">
                                    <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                                      color="greenMain" :disabled="isApproving || item?.status === 1"
                                      @click="handleWithdrawApprove(item)">
                                      <v-progress-circular v-if="isApproving" indeterminate size="16" width="2"
                                        color="white" class="mr-2" />
                                      {{ item?.status === 1 ? "Approved" : (isApproving ? "Approving..." : "Approve") }}
                                    </v-btn>
                                  </div>
                                </v-col>
                                <v-col cols="6">
                                  <div class="button-wrapper">
                                    <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                                      color="#FF567F" :disabled="item?.status === 1 || isApproving"
                                      @click="handleOpenRejectDialog()">
                                      Rejected
                                    </v-btn>
                                  </div>
                                </v-col>
                              </v-row>

                              <v-row v-if="item?.status === 2 || showRejectionCauseSection">
                                <v-col cols="12">
                                  <h2>Rejection Cause</h2>
                                </v-col>

                                <v-col cols="12" v-if="item?.status !== 2">
                                  <fieldset>
                                    <legend>Reason</legend>
                                    <v-select v-model="selectedReason" solo :items="slots5"
                                      append-icon="mdi-chevron-down" label="Click to select" class="custom-select"
                                      hide-details />
                                  </fieldset>
                                </v-col>

                                <v-col cols="12" v-if="item?.status === 2 || selectedReason === 'Other'">
                                  <fieldset>
                                    <legend>{{ item?.status === 2 ? "Reason" : "Write Your Reason" }}</legend>
                                    <v-text-field :disabled="item?.status === 2" v-model="reason" single-line
                                      :label="item?.status === 2 ? item?.reason : 'Write here'" solo hide-details
                                      class="custom-select" />
                                  </fieldset>
                                </v-col>

                                <v-col cols="6" v-if="item?.status !== 2">
                                  <div class="button-wrapper">
                                    <v-btn small tile elevation="0" block class="ma-0 text-capitalize btn-account py-4"
                                      color="#FF567F" :disabled="isRejecting" @click="handleRejectWithdraw(item)">
                                      <v-progress-circular v-if="isRejecting" indeterminate size="16" width="2"
                                        color="white" class="mr-2" />
                                      {{ isRejecting ? "Rejecting..." : "Confirm Reject" }}
                                    </v-btn>
                                  </div>
                                </v-col>

                                <v-col cols="6" v-if="item?.status !== 2">
                                  <div class="button-wrapper">
                                    <v-btn small tile elevation="0" block outlined
                                      class="ma-0 text-capitalize btn-account py-4" @click="handleCloseRejectDialog()">
                                      Cancel
                                    </v-btn>
                                  </div>
                                </v-col>
                              </v-row>

                            </v-card-text>
                          </v-card>
                        </template>
                      </v-dialog>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formatMySQLDate } from "@/_helpers/formateDate";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import router from "@/router";
import toast from "@/services/Notification";
import { PARTNERWITHDRAW__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import QRCode from "qrcode"; //  ADDED: QR code library

export default {
  data() {
    return {
      errors: { pay_slip: "" },
      pay_slip: null,
      previewUrl: null,
      search: "",
      searchTimeout: null,
      isApproving: false,
      isRejecting: false,
      excelLoading: false,

      options: { page: 1, itemsPerPage: 10 },

      selectedStatus: "",
      seletedDropdownTrx: "",
      seletedDropdownStatus: "",

      selectedDates: [],
      selectedDatesText: null,

      copiedStates: {},
      modal: false,
      dialog: false,

      reason: null,
      remarks: null,
      showButtons: true,
      selectedReason: null,

      detailsDialog: {},
      selectedFile: null,
      showRejectionCauseSection: false,

      slots5: [
        "Deposit and withdrawal method must be same",
        "Not enough balance",
        "Can't transfer funds to third party accounts",
        "Any fraudulent activity we must suspend the principal account until investigation of compliance",
        "Other",
      ],

      date: ["2022-01-01", "2023-01-01"],

      updateslots: [
        { status: 0, statusText: "Pending" },
        { status: 1, statusText: "Approved" },
        { status: 2, statusText: "Rejected" },
      ],

      headers: [
        { text: "Date and Time", value: "created_at" },
        { text: "Name", value: "account_fullname" },
        { text: "Email", value: "account_email" },
        { text: "Amount", value: "amount" },
        { text: "Trx Method", value: "payment_system" },
        { text: "Remarks", value: "remarks" },
        { text: "Action By", value: "admin_name" },
        { text: "Status", value: "status" },
        { text: "Details", value: "details" },
      ],

      // ADDED: QR states
      walletQr: {},
      qrLoading: {},
      walletCopied: {},
    };
  },

  computed: {
    ...mapState("partnerwithdraw", [
      "withdraws",
      "totalApprovedRequests",
      "trxMethods",
      "pagination",
      "range",
      "isFetchLoading",
    ]),
    ...mapState("admins", ["loggedAdmin"]),

    isItOpen() {
      return function (item) {
        return item?.status !== 2;
      };
    },

    allStatus() {
      return [
        { id: -1, value: -1, text: "All" },
        { id: 9, value: 0, text: "Pending" },
        { id: 10, value: 1, text: "Approved" },
        { id: 11, value: 2, text: "Rejected" },
      ];
    },
  },

  methods: {
    formatMySQLDate,

    ...mapActions("partnerwithdraw", [
      PARTNERWITHDRAW__ACTIONS.PARTNERWITHDRAW,
      PARTNERWITHDRAW__ACTIONS.CHANGESTATUS,
      PARTNERWITHDRAW__ACTIONS.PARTNERWITHDRAWEXCEL,
    ]),

    isImage(url) {
      return /\.(jpeg|jpg|png|gif|bmp|webp)$/i.test(url || "");
    },

    isPDF(url) {
      return /\.pdf$/i.test(url || "");
    },

    onFileChange(file) {
      if (file && file.size < 2000000) {
        this.pay_slip = file;
        const reader = new FileReader();
        reader.onload = (e) => (this.previewUrl = e.target.result);
        reader.readAsDataURL(file);
        this.errors.pay_slip = "";
      } else {
        this.pay_slip = null;
        this.previewUrl = null;
        this.errors.pay_slip = "File size should be less than 2MB";
      }
    },

    //  CHANGED: now accepts full item, keeps old slip preview behavior, and triggers QR generation
    handleFile(item) {
      this.selectedFile = item?.payment_slip || null;
      this.pay_slip = null;
      this.previewUrl = null;

      if (this.shouldShowWalletQr(item)) {
        this.generateWalletQr(item);
      }
    },

    handleClose(item) {
      this.$set(this.detailsDialog, item?.id, false);
      this.previewUrl = null;
      this.pay_slip = null;
      this.selectedFile = null;
    },

    downloadFile(fileUrl) {
      if (!fileUrl) return;
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = true;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    openInNewTab(url) {
      if (url) window.open(url, "_blank");
    },

    async handleWithdrawApprove(item) {
      try {
        this.isApproving = true;

        const formData = new FormData();
        formData.append("id", item?.id);
        formData.append("status", 1);
        formData.append("remarks", this.remarks || "N/A");
        if (this.pay_slip) formData.append("payment_slip", this.pay_slip);

        await this[PARTNERWITHDRAW__ACTIONS.CHANGESTATUS](formData);

        this.pay_slip = null;
        this.previewUrl = null;
        this.remarks = "";
      } catch (error) {
        console.error("Error approving withdrawal:", error);
      } finally {
        this.isApproving = false;
      }
    },

    handleOpenRejectDialog() {
      this.showRejectionCauseSection = true;
      this.showButtons = false;
    },

    handleCloseRejectDialog() {
      this.showRejectionCauseSection = false;
      this.showButtons = true;
      this.selectedReason = null;
    },

    canHandleMethod(item) {
      const prettyName = item?.payment_system?.pretty_name;
      if (prettyName === 'cash-withdraw') return this.$canRoute('cash-transfer') === 1;
      if (prettyName === 'bank-transfer') return this.$canRoute('bank-transfer') === 1;
      if (prettyName === 'crypto-transfer') return this.$canRoute('crypto-transfer') === 1;
      return true;
    },

    async handleRejectWithdraw(item) {
      try {
        this.isRejecting = true;

        const formData = new FormData();
        formData.append("id", item?.id);
        formData.append("status", 2);
        formData.append("reason", this.reason || this.selectedReason || "N/A");
        if (this.pay_slip) formData.append("payment_slip", this.pay_slip);

        await this[PARTNERWITHDRAW__ACTIONS.CHANGESTATUS](formData);

        this.showRejectionCauseSection = false;
        this.showButtons = true;
        this.selectedReason = null;
        this.reason = null;
      } catch (error) {
        console.error("Error rejecting withdrawal:", error);
      } finally {
        this.isRejecting = false;
      }
    },

    handleStatusChange() {
      this.options.page = 1;
      this.fetchData();
    },

    handleTrxMethodChange() {
      this.options.page = 1;
      this.fetchData();
    },

    async handleSelectChange(item) {
      try {
        this.selectedStatus = item.status;
        const parameter = { id: item?.id, status: item?.status };
        await this[PARTNERWITHDRAW__ACTIONS.CHANGESTATUS](parameter);
      } catch (error) {
        console.error("Error changing status:", error);
        toast.error("Failed to update status. Please try again.");
        this.$nextTick(() => {
          item.status = this.withdraws.find((w) => w.id === item.id)?.status || 0;
        });
      }
    },

    obfuscateAnyEmail(email) {
      return obfuscateEmail(email);
    },

    copyText(item) {
      navigator.clipboard.writeText(item.account_email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => this.$set(this.copiedStates, item.id, false), 1000);
    },

    async downloadCSVexcel() {
      await this[PARTNERWITHDRAW__ACTIONS.PARTNERWITHDRAWEXCEL]({
        limit: -1,
        search: this.search,
        payment_system_id: this.seletedDropdownTrx > 0 ? this.seletedDropdownTrx : null,
        status:
          this.seletedDropdownStatus === -1 ? null :
          this.seletedDropdownStatus === 0 ? "0" :
          this.seletedDropdownStatus,
        duration: this.selectedDates?.length === 2 ? `${this.selectedDates[0]}to${this.selectedDates[1]}` : null
      });
    },

    getTextColor(item) {
      return item.status === 1 ? "text-approved" : item.status === 2 ? "text-decline" : "text-pending";
    },

    async fetchData() {
      try {
        const params = {
          page: this.options.page || 1,
          limit: this.options.itemsPerPage || 10,
          search: this.search,
          payment_system_id: this.seletedDropdownTrx > 0 ? this.seletedDropdownTrx : null,
          status:
            this.seletedDropdownStatus === -1
              ? null
              : this.seletedDropdownStatus === 0
                ? "0"
                : this.seletedDropdownStatus,
        };

        if (this.selectedDates?.length === 2) {
          params.duration = `${this.selectedDates[0]}to${this.selectedDates[1]}`;
        }

        await this[PARTNERWITHDRAW__ACTIONS.PARTNERWITHDRAW](params);
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to load withdrawal data");
      }
    },

    async handleSearch() {
      this.options.page = 1;
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => this.handleSearch(), 500);
    },

    handleOptionsChange() {
      this.fetchData();
    },

    cancelSelection() {
      this.modal = false;
      this.selectedDates = [];
      this.selectedDatesText = null;
      this.fetchData();
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        toast.error("Please select both start and end dates");
        return;
      }

      let [startDate, endDate] = this.selectedDates;
      if (new Date(startDate) > new Date(endDate)) [startDate, endDate] = [endDate, startDate];

      this.selectedDatesText = `${startDate} ~ ${endDate}`;
      this.modal = false;
      this.options.page = 1;
      this.fetchData();
    },

    // =========================
    // ADDED: QR Helpers
    // =========================
    extractWalletCandidate(raw) {
      if (!raw) return "";
      const cleaned = String(raw).trim();
      const parts = cleaned.split(/\s+/).filter(Boolean);
      const preferred = parts.find((p) => p.startsWith("0x")) || parts[0];
      return (preferred || "").trim();
    },

    isValidCryptoAddress(addr) {
      if (!addr) return false;
      const a = String(addr).trim();

      if (/^0x[a-fA-F0-9]{40}$/.test(a)) return true; // EVM (ERC20/BEP20)
      if (/^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(a)) return true; // TRON (TRC20)
      if (/^(bc1)[0-9a-z]{25,90}$/.test(a)) return true; // BTC segwit
      if (/^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$/.test(a)) return true; // BTC legacy
      if (/^(ltc1)[0-9a-z]{25,90}$/.test(a)) return true; // LTC segwit
      if (/^[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}$/.test(a)) return true; // LTC legacy
      if (/^r[1-9A-HJ-NP-Za-km-z]{24,34}$/.test(a)) return true; // XRP
      if (/^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(a)) return true; // SOL (base58-like)
      return false;
    },

    shouldShowWalletQr(item) {
      const candidate = this.extractWalletCandidate(item?.wallet_address);
      return !!candidate && this.isValidCryptoAddress(candidate);
    },

    async generateWalletQr(item) {
      const id = item?.id;
      const candidate = this.extractWalletCandidate(item?.wallet_address);

      if (!id || !candidate || !this.isValidCryptoAddress(candidate)) return;
      if (this.walletQr[id]) return;

      this.$set(this.qrLoading, id, true);
      try {
        const dataUrl = await QRCode.toDataURL(candidate, {
          errorCorrectionLevel: "M",
          margin: 1,
          width: 220,
        });
        this.$set(this.walletQr, id, dataUrl);
      } catch (e) {
        console.error("QR generate failed:", e);
        this.$set(this.walletQr, id, null);
      } finally {
        this.$set(this.qrLoading, id, false);
      }
    },

    async copyToClipboard(text) {
      const value = (text || "").trim();
      if (!value) return false;

      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
        return true;
      }

      const el = document.createElement("textarea");
      el.value = value;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(el);
      return ok;
    },

    async copyWalletAddress(item) {
      const id = item?.id;
      const candidate = this.extractWalletCandidate(item?.wallet_address) || item?.wallet_address;
      if (!candidate) return;

      try {
        await this.copyToClipboard(candidate);
        this.$set(this.walletCopied, id, true);
        setTimeout(() => this.$set(this.walletCopied, id, false), 1000);
      } catch (e) {
        console.error("Copy failed:", e);
      }
    },
  },

  async created() {
    try {
      await this.fetchData();
      if (this.range) {
        this.selectedDatesText = `${this.range.start} ~ ${this.range.end}`;
      }
    } catch (error) {
      console.error("Error initializing component:", error);
    }
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.status-selection {
  min-width: 150px;
}

/* ADDED: QR styles */
.qr-fieldset {
  width: 320px;
  max-width: 100%;
  min-height: 255px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.qr-wrap {
  min-height: 190px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.qr-img {
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.85);
  padding: 10px;
  max-width: 100%;
}
</style>
